import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import App from './App';
import theme from './theme';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              borderRadius: '14px',
              background: '#0f172a',
              color: '#f8fafc',
              fontSize: '0.85rem',
              fontWeight: 500,
              padding: '14px 18px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.15), 0 0 0 1px rgba(79,70,229,0.1)',
              border: '1px solid rgba(255,255,255,0.05)',
            },
            success: {
              iconTheme: { primary: '#10b981', secondary: '#f8fafc' },
              style: { borderLeft: '4px solid #10b981' },
            },
            error: {
              iconTheme: { primary: '#ef4444', secondary: '#f8fafc' },
              style: { borderLeft: '4px solid #ef4444' },
            },
          }}
        />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
